import { render, staticRenderFns } from "./activities-tab.vue?vue&type=template&id=3db45fd0"
import script from "./activities-tab.vue?vue&type=script&lang=js"
export * from "./activities-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports